module.exports = "<button (click)=\"loginWithGoogle()\">Login with google</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.component.html
// module id = ./src/app/pages/login/login.component.html
// module chunks = main